import { FavyColumns } from "./FavyColumns";
import { ThemeContext } from "./ThemeContext";

export const FavyColumnsPhone = (props) => (
	<ThemeContext.Provider value={{ rendersPhoneLink: true, ...props }}>
		<FavyColumns {...props} />
	</ThemeContext.Provider>
);
